import { Home, FileText, BarChart2, Layers2, ShoppingCart, Truck, TrendingUp } from "lucide-react";

// Reports
export const reports = [
    { 
        id: "accueil", 
        name: "Accueil", 
        src: null, 
        icon: Home, 
        category: "HOME",
        
    },
    { 
        id: "creation", 
        name: "Création article & Nomenclature", 
        src: "CADLINK_Oryx_PROD.php", 
        icon: FileText, 
        category: "BUREAU D'ÉTUDE",
        allowedRoles: ["admin", "article"] 
    },
    { 
        id: "chiffre", 
        name: "Chiffre", 
        src: "https://app.powerbi.com/view?r=eyJrIjoiODVmNDg2MDAtNGI2MC00NzkxLWFkNDMtMzlkNmU1OGE0YjA3IiwidCI6ImU5YTJhNDE5LWVjNDUtNDljYy1hNTgyLTgwMDFkYjkxMjczMCJ9", 
        icon: TrendingUp, 
        category: "KPI ELCOM",
        allowedRoles: ["admin", "chiffre"]
    }, 
    {
        id: "logistique",
        name: "Logistique",
        src: "https://app.powerbi.com/view?r=eyJrIjoiZGU3YTcyZmYtMmRkOS00NWMzLTg2MTQtZDRlZjdlNGU1YTE5IiwidCI6ImU5YTJhNDE5LWVjNDUtNDljYy1hNTgyLTgwMDFkYjkxMjczMCJ9",
        icon: BarChart2, 
        category: "KPI ELCOM",
        allowedRoles: ["admin", "logistique"]
    },
    { 
        id: "achat", 
        name: "Performances fournisseurs", 
        src: "https://app.powerbi.com/view?r=eyJrIjoiODMwZGFiNTgtZjE3Ni00MDFjLWFhOTYtNTc1OWM4Y2NlMmZjIiwidCI6ImU5YTJhNDE5LWVjNDUtNDljYy1hNTgyLTgwMDFkYjkxMjczMCJ9", 
        icon: ShoppingCart,
        category: "KPI ELCOM",
        allowedRoles: ["admin", "achat"]
    }, 
    { 
        id: "transporteur", 
        name: "Historique transporteur", 
        src: "https://app.powerbi.com/view?r=eyJrIjoiMDM0Y2EwMjMtZTQxYy00ZTI2LWFiMWMtNzhlNTg5ZTViYzNjIiwidCI6ImU5YTJhNDE5LWVjNDUtNDljYy1hNTgyLTgwMDFkYjkxMjczMCJ9", 
        icon: Truck,
        category: "KPI ELCOM",
        allowedRoles: ["admin", "transporteur"]
    }, 

    { 
        id: "article", 
        name: "Contrôle base article", 
        src: "https://app.powerbi.com/view?r=eyJrIjoiMmRiZWQwZTMtMzAwMS00NDA2LTllMGYtNmQxNTA4NGNjODZkIiwidCI6ImU5YTJhNDE5LWVjNDUtNDljYy1hNTgyLTgwMDFkYjkxMjczMCJ9", 
        icon: FileText,
        category: "KPI ELCOM",
        allowedRoles: ["admin", "article"]
    }, 
    
    {
        id: "Transport",
        name: "Transport",
        src: null,
        icon: BarChart2,
        category: "KPI ELCOM",
        allowedRoles: ["admin", "transport"]
    }
];

// Menu filtré
export const getMenuStructure = (userRoles = []) => {
    
    // Filtre Roles
    const filteredReports = reports.filter(report => {
        // Pas de restriction
        if (!report.allowedRoles) return true;
        
        // Admin
        if (userRoles.includes("admin")) return true;

        // Rôles requis
        return report.allowedRoles.some(role => userRoles.includes(role));
    });

    // Regroupe les rapports filtrés 
    const grouped = filteredReports.reduce((acc, report) => {
        // atégories
        if (report.category === "HOME" || report.category === "BUREAU D'ÉTUDE") {
            acc[report.category] = acc[report.category] || [];
            acc[report.category].push(report);
        } else if (report.category === "KPI ELCOM") {
            acc["KPI ELCOM"] = acc["KPI ELCOM"] || [];
            acc["KPI ELCOM"].push(report);
        }
        return acc;
    }, {});

    // Menu
    const menu = [
        { name: "HOME", items: grouped["HOME"] || [] },
        { name: "BUREAU D'ÉTUDE", items: grouped["BUREAU D'ÉTUDE"] || [] },
        { 
            name: "KPI ELCOM", 
            isSubmenu: true, 
            icon: BarChart2, 
            items: grouped["KPI ELCOM"] || [] 
        },
        { name: "COMPTE", items: [{ id: "logout", name: "Déconnexion", icon: Layers2, action: true }] },
    ];

    // 
    // Section Elcom
    return menu.filter(section => {
        if (section.id === "logout") return true; 
        return section.items && section.items.length > 0;
    });
};